import { h } from 'preact';
import getPageType from 'rum-pagetypes/src';
import Button from 'q-mdc/elements/material-button';
import MyAccountMenu from 'q-components/components/myAccount';
import {Quikr} from 'q-components/components/icons/headerIcons';
import apiCalls from './utils/FetchHelper.js';
import PostAdButton from './components/common/postAdButton';
import AutoSuggest from './components/common/AutoSuggest';
import constants from './constants/constants';
import Cookies from 'universal-cookie';
import { apiUrl, topCityList, stateList } from './config.js';
import { isMobileRequest } from './utils/CommonHelper.js';
import { buildNewCitySnbUrl } from './utils/UrlHelper';

const cookies = new Cookies();
const currentCityName = cookies.get('new_prefer_city') ? (cookies.get('new_prefer_city').toLowerCase() === 'www' ? 'all-india' : cookies.get('new_prefer_city')) : "all-india";

function getJKID () {
    const jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
    return jkidCookie && jkidCookie[0];
}

function getCitySpecificCategoryId (cityId, cityName, categoryId, gId){
    const isAllIndia = (cityId === 0 || cityId === 1);
    return new Promise(
        function (resolve, reject) {
            let params = {
                url: `${apiUrl}/ajax/get-city-category-id?aj=1&cityId=${cityId}&cityName=${cityName}&catId=${categoryId}`,
            };
            let apiHelper = new apiCalls();
            let citySearchData = apiHelper.request('get', params);
            citySearchData.then((res) => {
                if (res.data.id) {
                    resolve(res.data.id);
                } else {
                    reject('Something went wrong');
                }
            }).catch((err) => {
                reject('Something went wrong');
            });
        }
    );
}

function searchCityCallbackForSnb (cityId, cityName, globalId, match){
    cityId = cityId*1;
    const pageUrl = match.url;
    const matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    const gId = '0,'+cityName;
    getCitySpecificCategoryId(cityId, cityName, matches[1], gId).then((categoryId) => {
        window.location.href = buildNewCitySnbUrl(categoryId,cityName,match);
    }).catch((err) => {
    });
}

function searchStateCallback(stateId, stateName, globalId, match) {
    window.location.href = buildNewCitySnbUrl(stateId,stateName,match);
}

function searchCityCallbackForHP (cityId, cityName, globalId, match){
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);
    let pageUrl = match.url;
    const urlParts = pageUrl.split("/");
    if (isAllIndia){
        urlParts[urlParts.length-1] = "all-india";
    } else {
        urlParts[urlParts.length-1] = cityName.toLowerCase();
    }
    pageUrl = urlParts.join("/");
    window.location.href = pageUrl;
}
function searchCityCallbackForVap (cityId, cityName, globalId, match) {
    const { adId } = match.params;
    const apiHelper = new apiCalls();
    const params = {
        url: `${apiUrl}/ajax/get-city-url?aj=1&page=VAP&adId=${adId}&cityId=${cityId}`
    };
    apiHelper.request('get', params).then((response) => {
        if (response.status === 200 && response.data && response.data.href) {
            window.location.href = response.data.href;
        } else {
            window.location.href = `https://www.quikr.com/cars/used-cars/${cityName}`;
        }
    });
}

function searchStateCallbackForVap (stateId, stateName, globalId, match) {
    const { adId } = match.params;
    stateName = stateName.replace(/ /g, '-');
    const apiHelper = new apiCalls();
    const params = {
        url: `${apiUrl}/ajax/get-city-url?aj=1&page=VAP&adId=${adId}&stateId=${stateId}&stateName=${stateName}&isCarsStateLevelRequest=1`
    };
    apiHelper.request('get', params).then((response) => {
        if (response.status === 200 && response.data && response.data.href) {
            window.location.href = response.data.href;
        } else {
            window.location.href = `https://www.quikr.com/cars/used-cars/${stateName}`;
        }
    });
}

function handleVapPostAdClick (router){
    const { route: {match: {params: {adId}}} } = router;
    const params = {
        url: `${apiUrl}/ajax/get-postad-url?aj=1&adId=${adId}`
    };
    const apiHelper = new apiCalls();
    apiHelper.request('get', params).then((res) => {
        if (res.data.success) {
            window.location.href=res.data.href;
        } else {
            window.location.href=constants.baseUrl+"/post-classifieds-ads/select-category";
        }
    });
}

function hanldeHomePagePostAdClick () {
    const categoryId = localStorage.getItem('carsCategoryId');
    const mGlobal = localStorage.getItem('carsMglobal');
    if (categoryId && mGlobal) {
        switch (mGlobal) {
            case "71":
                window.location.href=constants.baseUrl+"/cars/sell-your-used-cars/?postadcategoryid="+categoryId;
                break;
            case "72":
                window.location.href=constants.baseUrl+"/bikes-scooters/sell-your-used-bikes-scooters/?postadcategoryid="+categoryId;
                break;
            case "139":
                window.location.href=constants.baseUrl+"/commercial-vehicles/sell-used-commercial-vehicles/?postadcategoryid="+categoryId;
                break;
            case "74":
                window.location.href=constants.baseUrl+"/spare-parts-accessories/sell-spare-parts-accessories/?postadcategoryid="+categoryId;
                break;
            default:
                window.location.href=constants.baseUrl+"/post-classifieds-ads/select-category";
                break;
        }
    } else {
        window.location.href=constants.baseUrl+"/post-classifieds-ads/select-category";
    }
}

function handlePostAdClick (router){
    const { route: {match} } = router;
    const type= match.params.type;
    const url= match.url;
    const matches=url.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    const catId=matches[1];
    if (type === 'cars'){
        window.location.href=constants.baseUrl+"/"+type+"/sell-your-used-cars/?postadcategoryid="+catId;
    } else if (type === 'bikes-scooters'){
        window.location.href=constants.baseUrl+"/"+type+"/sell-your-used-bikes-scooters/?postadcategoryid="+catId;
    } else if (url.indexOf('commercial-vehicles') !== -1){
        window.location.href=constants.baseUrl+"/"+type+"/sell-used-commercial-vehicles/?postadcategoryid="+catId;
    } else if (url.indexOf('spare-parts-accessories') !== -1) {
        window.location.href=constants.baseUrl+"/"+type+"/sell-spare-parts-accessories/?postadcategoryid="+catId;
    } else {
        window.location.href=constants.baseUrl+"/post-classifieds-ads/select-category";
    }
}

const getCookie = function (name) {
    const getCookieValues = function (cookie) {
        const cookieArray = cookie.split('=');
        return (cookieArray[1] === undefined) ? null : cookieArray[1].trim();
    };

    const getCookieNames = function (cookie) {
        const cookieArray = cookie.split('=');
        return (cookieArray[0] === undefined) ? null : cookieArray[0].trim();
    };

    const cookies = document.cookie.split(';');
    const cookieValue = cookies.map(getCookieValues)[cookies.map(getCookieNames).indexOf(name)];

    return (cookieValue === undefined) ? null : cookieValue;
};

function onSearchCallback (event, updateSearchSuggestions){
    const searchText = event.target.value;
    const city = getCookie('new_prefer_city')?getCookie('new_prefer_city'):'www';
    const cityId = getCookie('prefer_city_id')?getCookie('prefer_city_id'):1;

    if (searchText && searchText !== '' ) {
        const apiHelper = new apiCalls();
        const ajaxHost = (location.hostname === "localhost")? constants.baseUrl: "";
        const params = {
            url: ajaxHost + '/common?aj=1&for=searchautosuggest&metacatglobalid=60&data='+searchText+'&subdom='+city+'&cityid='+cityId+'&rand='+new Date().getTime()
        };

        const suggestionsPromise = apiHelper.request('get', params);

        suggestionsPromise.then((response) => {
            const title = 'Search Results';
            const data = (response.data)?response.data:{};
            if (data) {
                updateSearchSuggestions(<AutoSuggest data={data} title={title} />);
            }
        });
    }
}

function citySearchCallBack (keyWord, updateCityList) {
    if (keyWord !== '') {
        const apiHelper = new apiCalls();
        const data = new URLSearchParams();
        data.append('param', keyWord);
        const params = {
            url: "https://www.quikr.com/siteheaderfooter?aj=1&for=suggestCities",
            data
        };
        apiHelper.request('post', params).then((response) => {
            if (response.status === 200) {
                const { suggCities=[] } = response.data;
                updateCityList(suggCities);
            }
        });
    }
}

function logoCallBack (props, context) {
    if (isMobileRequest()) {
        return <a class="logo" href={`https://www.quikr.com/cars/used-cars/${currentCityName}`} ><Quikr class="mdc-toolbar__icons" /><span class="link-text-hidden">Quikr</span></a>;
    }
    const { match: { params : { type } } } = props;
    let logoUrl;
    let href;
    let alt;
    if (type == 'bikes-scooters') {
        logoUrl = 'https://teja8.kuikr.com/module_assets/images/quikr_bikes_logo.png';
        href = `https://www.quikr.com/bikes-scooters/${currentCityName}`;
        alt = `QuikrBikes - Best place to buy Used Bikes in India`;
    } else {
        logoUrl  = 'https://teja8.kuikr.com/module_assets/images/quikr_cars_logo.png';
        href = `https://www.quikr.com/cars/used-cars/${currentCityName}`;
        alt = 'QuikrCars - Best place to buy New and Used Cars in India';
    }
    
    return <a href={href} title={alt} class="logo" ><img alt={alt} src={logoUrl} class="cars-logo"/><span class="link-text-hidden">Quikr</span></a>
}

function handleVapBackClick (e, history, match) {
    if (typeof document.referrer === "undefined" || document.referrer === "") {
        const { adId } = match.params;
        const apiHelper = new apiCalls();
        const params = {
            url: `${apiUrl}/ajax/get-city-url?aj=1&page=SNB&adId=${adId}`
        };
        apiHelper.request('get', params).then((response) => {
            window.location.href = response.data.href;
        });
    } else {
        history.goBack();
    }
    return;
}

function getCurrentCityId () {
    const cityCookie = cookies.get('prefer_city_id') || '1';
    return cityCookie;
}

//Get userTab on header based on user loggedin Status
const LoggedOutMenu = [
    { title: 'My Cart', href: '/QuikrX/Cart', gaEventName: 'cart' },
    { title: 'Login/Register', href: '/SignIn', onClick: (e) => { e.preventDefault();window.location.href=`/SignIn?redirect=${window.location.href}`} }
];

const LoggedInMenu = [
    { href: '/MyQuikr', title: 'My Account', gaEventName: 'account' },
    { href: '/MyQuikr?action=activeads', title: 'My Ads', gaEventName: 'ads' },
    { title: 'My Cart', href: '/QuikrX/Cart', gaEventName: 'cart' },
    { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm', gaEventName: 'doorstep_offers' },
    { href: '/MyQuikr?action=mychats', title: 'My Chats', gaEventName: 'chats' },
    { href: '/QuikrX/myorders', title: 'My Orders', gaEventName: 'orders' },
    { title: 'Logout', href: '/bye', gaEventName: 'logout' }
];

export const shellConfig = [
    {
        route: { path: "/:type(cars|cars-bikes|bikes-scooters)/:title([0-9a-zA-Z+\\-\\.\\,]+)\\+:city([a-zA-Z0-9]+)\\+W0QQAdIdZ:adId([0-9]+)", exact: true },
        header: {
            show: true,
            hasTitle: false,
            hamburger: false,
            logoCallback: logoCallBack,
            toolbarItems: true,
            back: true,
            handleBackClick: handleVapBackClick
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAVap'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const ptype = 'CNB_VAP_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: { path: '/cars-bikes/ImageGallery/:id', exact: true },
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAGallery'}
    }, {
        route: { path: '/cars-bikes/:b(\\used-.*-model-images-\\d+)', exact: true },
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAGallery'}
    }, {
        route: { path: '/:type(cars|bikes-scooters)/(used-car-showroom|used-bike-showroom)-:name([a-zA-Z]+)-:city([a-zA-Z]+)-:id([0-9]+)', exact: true },
        header: {
            show: true,
            hasTitle: false,
            logoHref: 'https://www.quikr.com/cars/used-cars/'+currentCityName,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePointLP'}
    },{
        route: { path: '/:type(cars|bikes-scooters)/:subType(car-yards|bike-points)-in-:slug([a-zA-Z0-9\-]+)', exact: true },
        header: {
            show: false
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePoint'},
        qrum: (location, match) => {
            let type = 'NA';
            if (typeof match !== 'undefined') {
                type = match && match.params && match.params.type;
            }
            const ptype = 'CNB_CARYARDS_BIKEPOINTS_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: type, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: { path: '/:type(cars|cars-bikes|bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)', exact: true },
        header: {
            show: true,
            hasTitle: true,
            back: false,
            logoHref: 'https://www.quikr.com/cars/used-cars/'+currentCityName,
            logoCallback: logoCallBack,
            searchCityCallback: searchCityCallbackForSnb,
            toolbarItems: true
        },
        search: { show: true, onSearchCallback },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWASnB'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const ptype = 'CNB_SNB_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: {
            path: '/:subCat(cars-bikes)/rto-services/:slug([a-zA-Z0-9]+)',
            exact: true
        },
        header: {
            show: false,
            hasTitle: false,
            hamburger: false,
            back: true,
            logoHref: 'https://www.quikr.com/cars/used-cars/'+currentCityName,
            searchCityCallback: searchCityCallbackForHP,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWARTOPage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }
            const ptype = 'CNB_RTO_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: { path: '/:subCat(cars-bikes)/inspection/:id([a-zA-Z0-9]+)', exact: true },
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAInspectionPage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }

            const ptype = 'CNB_INSPECTION_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: { path: '/cars-bikes/partnerships/:slug([a-zA-Z0-9-]+)', exact: true },
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAPartnership'}
    },{
        route: { path: '/cars-bikes/warranty/payment-success', exact: true},
        header: {
            show: true,
            hasTitle: false,
            location: false,
            logoCallback: logoCallBack
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAPaymentSuccess'}
    }, {
        route: {
            // Cars HP
            path: '/:subCat(cars)/:type(used-cars|new-cars)/:slug([a-zA-Z0-9-]+)',
            exact: true
        },
        header: {
            show: true,
            hasTitle: true,
            hamburger: true,
            back: false,
            logoHref: 'https://www.quikr.com/cars/used-cars/'+currentCityName,
            searchCityCallback: searchCityCallbackForHP,
            toolbarItems: true,
            marketTalkButton: true
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }
            const ptype = 'CNB_HP_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: {
            path: '/:subCat(bikes-scooters|commercial-vehicles)/:slug([a-zA-Z0-9-]+)',
            exact: true
        },
        header: {
            show: true,
            hasTitle: true,
            hamburger: true,
            back: false,
            logoHref: 'https://www.quikr.com/bikes-scooters/'+currentCityName,
            searchCityCallback: searchCityCallbackForHP,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }
            const ptype = 'CNB_HP_MOBILE';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }
];

export const desktopShellConfig = [
    {
        route: { path: '/:type(cars|bikes-scooters)/(used-car-showroom|used-bike-showroom)-:name([a-zA-Z]+)-:city([a-zA-Z]+)-:id([0-9]+)', exact: true },
        header: {
            show: true,
            hasTitle: false,
            location: false,
            logoCallback: logoCallBack,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePointLPDesk'}
    },{
        route: { path: '/:type(cars|bikes-scooters)/:subType(car-yards|bike-points)-in-:slug([a-zA-Z0-9\-]+)', exact: true },
        header: {
            show: true,
            logoCallback: logoCallBack,
        },
        search: { show: false},
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWACarYardBikePoint'},
        qrum: (location, match) => {
            let type = 'NA';
            if (typeof match !== 'undefined') {
                type = match && match.params && match.params.type;
            }
            const ptype = 'CNB_CARYARDS_BIKEPOINTS_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: type, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    },{
        route: {path: "/:type(cars|cars-bikes|bikes-scooters)/:title([0-9a-zA-Z+\\-\\.\\,]+)\\+:city([a-zA-Z0-9]+)\\+W0QQAdIdZ:adId([0-9]+)", exact: true},
        header: {
            show: true,
            hasTitle: true,
            hamburger: true,
            logoCallback: logoCallBack,
            searchCityCallback: searchCityCallbackForVap,
            cityList: topCityList,
            stateList,
            citySearchCallBack,
            cityModal: true,
            searchStateCallback: searchStateCallbackForVap,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAVap'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const ptype = 'CNB_VAP_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    },{
        route: { path: '/:type(cars|cars-bikes|bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)', exact: true},
        header: {
            show: true,
            hasTitle: true,
            back: false,
            logoHref: 'https://www.quikr.com/cars/used-cars/'+currentCityName,
            logoCallback: logoCallBack,
            searchCityCallback: searchCityCallbackForSnb,
            cityList: topCityList,
            stateList,
            citySearchCallBack,
            cityModal: true,
            searchStateCallback,
            toolbarItems: true
        },
        search: {show: true, onSearchCallback},
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWASnB'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const ptype = 'CNB_SNB_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    },{
        route: { path: '/:subCat(cars-bikes)/inspection/:id([a-zA-Z0-9]+)', exact: true},
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false},
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAInspectionPage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }

            const ptype = 'CNB_INSPECTION_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    },{
        route: { path: '/cars-bikes/partnerships/:slug([a-zA-Z0-9-]+)', exact: true},
        header: {
            show: false,
            hasTitle: false
        },
        search: { show: false},
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAPartnership'}
    },{
        route: { path: '/cars-bikes/warranty/payment-success', exact: true},
        header: {
            show: true,
            hasTitle: false,
            location: false,
            logoCallback: logoCallBack
        },
        search: { show: false },
        footer: { show: true },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAPaymentSuccess'}
    }, {
        route: {
            // Cars HP
            path: '/:subCat(cars)/:type(used-cars|new-cars)/:slug([a-zA-Z0-9-]+)',
            exact: true
        },
        header: {
            show: true,
            hasTitle: true,
            hamburger: true,
            back: false,
            logoCallback: logoCallBack,
            searchCityCallback: searchCityCallbackForHP,
            cityList: topCityList,
            stateList,
            citySearchCallBack,
            cityModal: true,
            searchStateCallback: searchStateCallbackForVap,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.subCat;
            }
            const ptype = 'CNB_HP_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }, {
        route: {
            path: '/:type(bikes-scooters|commercial-vehicles)/:slug([a-zA-Z0-9-]+)',
            exact: true
        },
        header: {
            show: true,
            hasTitle: true,
            hamburger: true,
            back: false,
            logoCallback: logoCallBack,
            searchCityCallback: searchCityCallbackForHP,
            cityList: topCityList,
            stateList,
            citySearchCallBack,
            cityModal: true,
            searchStateCallback: searchStateCallbackForVap,
            toolbarItems: true
        },
        search: { show: false },
        footer: { show: false },
        ga: {accountId: 'UA-5568615-7', trackerName: 'CarsPWAHomePage'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const ptype = 'CNB_HP_DESKTOP';
            const config = { PTYPE: getPageType(ptype), CAT: category, CITY: getCurrentCityId(), JKID: getJKID() };
            return config;
        }
    }
];



// WEBPACK FOOTER //
// ../q-cars/src/shellConfig.js